import { Component, Input, OnInit } from '@angular/core';
import { BillInterface } from '../../../../bills/models/bill.interface';
import { GetLines } from '../../../../lines/store/actions/lines.actions';
import { select, Store } from '@ngrx/store';
import { ConstsHelper } from '../../../../../helpers/consts.helper';
import { LinesInterfaceState } from '../../../../lines/store/state/lines.state';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';
import { BillProtestInterface } from '../../../models/bill-protest.interface';
import { environment } from '../../../../../../environments/environment';
import { FileService } from '../../../services/file.service';
import { SaveCustomerMission } from '../../../store/actions/customer-mission.actions';
import { GetBillGsmDetails } from '../../../store/actions/bill-gsm-details.actions';
import { BillGsmDetailsInterfaceState } from '../../../store/state/bill-gsm-details.state';
import { BillGsmDetailsInterface } from '../../../../bills/models/bill-gsm-details.interface';
import { PriceFormatService } from '../../../services/price-format.service';
import moment from 'moment';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { FormControl, Validators } from '@angular/forms';
import { BillGsmDetailsPaginatorInterface } from '../../../../bills/models/bill-gsm-details.paginator.interface';
import { PaginatorInterface } from '../../../models/paginator.interface';
import { UpdatePaginator } from '../../../store/actions/paginator.actions';
import { CustomerReportingService } from '../../../services/customer-reporting.service';
import { CustomerInterface } from '../../../../account/models/customer.interface';
import { CustomerStorageService } from '../../../../account/services/customer-storage.service';
import { GetLandLineList } from '../../../../landlines/store/actions/land-line-list.actions';
import { LandLineListInterfaceState } from '../../../../landlines/store/state/land-line-list.state';
import { LineBillProtestInterface } from '../../../models/line-bill-protest.interface';

@Component({
    selector: 'app-bill-protest',
    templateUrl: './bill-protest.component.html',
    styleUrls: ['./bill-protest.component.css'],
    standalone: false
})
export class BillProtestComponent implements OnInit {

  @Input()
  bills: Array<BillInterface>;

  @Input()
  procedureCode: string;

  bill: BillInterface;
  lines: Array<LineBillProtestInterface>;
  billGsmDetails: BillGsmDetailsPaginatorInterface;
  billGsmDetailsCopy: Array<BillGsmDetailsInterface>;
  selectedLine: LineBillProtestInterface;
  protestedCommunications: Array<number> = [];
  step: number;
  motif: string;
  file = File;
  displayMessageError: boolean;
  displayCommunicationError: boolean;
  details: string;
  fileNameDisplay: string;
  date: string = null;
  minDate: string;
  maxDate: string;
  displayDateError: boolean;
  displayDateRangeError: boolean;
  realTerminationLineDate: string;
  firstLastMonthCase: boolean;
  terminationDateControl: FormControl;
  submitted: boolean;
  currentSelectedPage: number;
  totalItemsPerPage: number;
  customer: CustomerInterface = null;
  brand?: string;

  constructor(
      private store: Store<any>,
      private fileService: FileService,
      public priceFormatService: PriceFormatService,
      private matIconRegistry: MatIconRegistry,
      private domSanitizer: DomSanitizer,
      private customerReportingService: CustomerReportingService,
      private customerStorageService: CustomerStorageService
  ) {}

  ngOnInit() {
    this.brand = environment.data.brand;
    this.customer = this.customerStorageService.getCustomer();
    this.bill = this.bills[0];
    this.setPenalty();
    this.submitted = false;
    this.currentSelectedPage = 1;
    this.totalItemsPerPage = 5;
    this.displayDateRangeError = false;
    this.displayCommunicationError = false;
    this.firstLastMonthCase = false;
    this.billGsmDetails = null;
    this.billGsmDetailsCopy = [];
    this.lines = [];
    this.details = '';
    this.displayDateError = false;
    this.store.dispatch(new GetLines());
    this.selectedLine = null;
    this.realTerminationLineDate = null;
    this.motif = null;
    this.step = 1;
    this.matIconRegistry.addSvgIcon(
      'agenda',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../../../../../../../assets/images/icons/' + this.brand + '_small-agenda.svg'
      )
    );
    this.minDate = moment(new Date()).subtract(180, 'd').format('YYYY-MM-DD');
    this.maxDate = moment(new Date()).format('YYYY-MM-DD');
    this.terminationDateControl = new FormControl('',[Validators.required]);

    this.store.pipe(select(ConstsHelper.REDUCER_LAND_LINES_LIST)).subscribe((response: LandLineListInterfaceState) => {
      if (response.list instanceof Array && response.list.length > 0) {
        for (const line of response.list) {
          this.lines.push(
              {
                phoneNumber: line.phoneNumber,
                offerLabel: null,
                offerId: line.offerId,
                offerGt: null,
                status: line.status,
                retractionDate: null,
                billEndDate: ['', null].indexOf(line.billingFinishDate) === -1 ? line.billingFinishDate : null
              }
          );
          this.selectedLine = this.lines[0];
        }
      }
    });

    this.store.pipe(select(ConstsHelper.REDUCER_BILL_GSM_DETAILS)).subscribe((response: BillGsmDetailsInterfaceState) => {
      if (response.list) {
        this.billGsmDetails = response.list;
        if ((this.billGsmDetailsCopy.length === 0 && this.billGsmDetails.data.length > 0) || (this.billGsmDetailsCopy.length > 0 && this.billGsmDetails.currentPage !== this.currentSelectedPage)) {
          this.billGsmDetailsCopy = this.billGsmDetails.data;
          this.currentSelectedPage = this.billGsmDetails.currentPage;
          this.firstLastMonthCase = !(this.billGsmDetailsCopy.length);
        }
        this.store.dispatch(new UpdatePaginator(this.getPaginator()));
      }
    });

    this.store.pipe(select(ConstsHelper.REDUCER_LINES)).subscribe((response: LinesInterfaceState) => {
      if (response.lines instanceof Array) {
        for (const line of response.lines) {
          this.lines.push(
              {
                phoneNumber: line.phoneNumber,
                offerLabel: line.offer.labelTunnel,
                offerId: line.offer.id,
                offerGt: line.offer.offerGt,
                status: line.status,
                retractionDate: ['', null, undefined].indexOf(line.retractionDate) === -1 ? line.retractionDate : null,
                billEndDate: line.billEndDate
              }
          );
          if (this.lines.length === response.lines.length) {
            this.selectedLine = this.lines[0];
            this.store.dispatch(new GetLandLineList());
          }
        }
        if (response.lines.length === 0) {
          this.store.dispatch(new GetLandLineList());
        }
      }
    });
  }

  setSelectedLine(event) {
    for (const line of this.lines) {
      if (line.phoneNumber === event.target.value) {
        this.selectedLine = line;
        this.setPenalty();
      }
    }
    this.protestedCommunications = [];
  }

  setSelectedBill(event) {
    for (const bill of this.bills) {
      if (bill.id === parseInt(event.target.value, 10)) {
        this.bill = bill;
        this.setPenalty();
      }
    }
    this.protestedCommunications = [];
  }

  getFile($event) {
    this.file = $event.target.files.item(0);
    if ($event.target.files.item(0)) {
      this.fileNameDisplay = $event.target.files.item(0).name;
    } else {
      this.fileNameDisplay = null;
    }
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }

  setStep(step: number) {
    if (step < 3) {
      this.billGsmDetailsCopy = [];
      this.displayMessageError = false;
      this.displayCommunicationError = false;
      this.displayDateError = false;
    }
    (
        this.motif === 'Vous ne comprenez pas pourquoi le premier et le dernier mois sont facturés comme les autres mois' ||
        this.motif === 'Vous ne comprenez pas pourquoi des pénalités de retard ont été facturées' ||
        this.motif === 'Vous ne comprenez pas la facturation en hors-forfait d\'une communication' && this.billGsmDetailsCopy && this.billGsmDetailsCopy.length === 0
    )
        ?
        this.firstLastMonthCase = true
        :
        this.firstLastMonthCase = false;

    this.realTerminationLineDate = null;
    this.billGsmDetailsCopy = [];
    if (step === 3) {
      if (this.motif === 'Vous ne comprenez pas pourquoi vous avez été facturé alors que votre ligne est résiliée') {
        if (this.selectedLine.status === 'Rétractée') {
          this.realTerminationLineDate = this.selectedLine.retractionDate;
        } else if (this.selectedLine.status === 'Résiliée') {
          this.realTerminationLineDate = this.selectedLine.billEndDate;
        }
      } else if (ConstsHelper.phoneNumberPattern.test(this.selectedLine.phoneNumber)) {
        this.store.dispatch(new GetBillGsmDetails(this.selectedLine.phoneNumber, parseInt(this.bill.month, 10), this.currentSelectedPage, this.totalItemsPerPage, null));
      }
    }
    this.step = step;
  }

  changeSelection(event) {
    if (event.target.checked) {
      this.protestedCommunications.push(parseInt(event.target.value, 10));
    } else {
      const index = this.protestedCommunications.indexOf(parseInt(event.target.value, 10));
      if (index !== -1) {
        this.protestedCommunications.splice(index, 1);
      }
    }
  }

  setTerminationDate($event) {
    this.date = $event;
    if (this.dateInValidRange($event)) {
      this.displayDateRangeError = false;
    }
  }

  dateInValidRange(date: string): boolean {
    const parsedDate = moment(date).format('YYYY-MM-DD');
    return new Date(parsedDate) <= new Date(this.maxDate) && new Date(parsedDate) >= new Date(this.minDate);
  }

  confirmation() {
    this.displayMessageError = false;
    this.displayCommunicationError = false;
    this.displayDateError = false;

    if (this.motif === 'Vous ne comprenez pas pourquoi vous avez été facturé alors que votre ligne est résiliée') {
      if (['Rétractée', 'Résiliée'].indexOf(this.selectedLine.status) !== -1) {
        this.date = null;
      } else if (this.date == null && ['Rétractée', 'Résiliée'].indexOf(this.selectedLine.status) === -1) {
        this.displayDateError = true;
      } else if (!this.dateInValidRange(this.date)) {
        this.displayDateRangeError = true;
      }
    }

    if (
        (this.details.length < 20 || this.details.length > 1000) &&
        ['Vous ne comprenez pas pourquoi le premier et le dernier mois sont facturés comme les autres mois', 'Vous ne comprenez pas pourquoi des pénalités de retard ont été facturées'].indexOf(this.motif) === -1
    ) {
      this.displayMessageError = true;
    }

    if (
        this.protestedCommunications.length === 0 &&
        this.motif === 'Vous ne comprenez pas la facturation en hors-forfait d\'une communication'
    ) {
      this.displayCommunicationError = true;
    }

    if (
        this.displayCommunicationError === false &&
        this.displayDateError === false &&
        this.displayMessageError === false &&
        this.displayDateRangeError === false &&
        this.submitted === false
    ) {
      this.submitted = true;
      const billProtest: BillProtestInterface = {
        phoneNumber: this.selectedLine.phoneNumber,
        offerId: this.selectedLine.offerId,
        offerLabel: this.selectedLine.offerLabel,
        offerGt: this.selectedLine.offerGt,
        externalId: this.bill.id.toString(),
        period: parseInt(this.bill.month, 10),
        details: this.details,
        protestedCommunications: this.protestedCommunications,
        motif: this.motif,
        lineStatus: this.selectedLine.status,
        fileId: null,
        terminationDate: this.date ? moment(this.date).format('YYYY-MM-DD') : null,
        realTerminationDate: this.selectedLine.billEndDate,
        step: 1,
        customerDetails: this.customer.civility + ' ' + this.customer.lastName + ' ' + this.customer.firstName
      };
      if (this.fileNameDisplay) {
        this.fileService.create(this.file, this.fileNameDisplay, environment.data.supportingDocumentsFileTypeSlug, environment.data.supportingDocumentsBucketSlug).subscribe( response => {
          billProtest.fileId = response.fileId;
          this.store.dispatch(new SaveCustomerMission(billProtest, this.procedureCode, 'bill'));
        });
      } else {
        this.store.dispatch(new SaveCustomerMission(billProtest, this.procedureCode, 'bill'));
      }
    }
  }

  getMonth(monthNumberToAdd: number, addSubText: boolean) {
    const date = this.realTerminationLineDate.split('-');
    const months = {
      '01' : addSubText ? 'de Janvier' : 'Janvier',
      '02' : addSubText ? 'de Février' : 'Février',
      '03' : addSubText ? 'de Mars' : 'Mars',
      '04' : addSubText ? 'd\'Avril' : 'Avril',
      '05' : addSubText ? 'de Mai' : 'Mai',
      '06' : addSubText ? 'de Juin' : 'Juin',
      '07' : addSubText ? 'de Juillet' : 'Juillet',
      '08' : addSubText ? 'd\'Août' : 'Août',
      '09' : addSubText ? 'de Septembre' : 'Septembre',
      '10' : addSubText ? 'd\'Octobre' : 'Octobre',
      '11' : addSubText ? 'de Novembre' : 'Novembre',
      '12' : addSubText ? 'de Décembre' : 'Décembre'
    };
    let monthKey = '';
    if ((parseInt(date[1], 10) + monthNumberToAdd) < 10) {
      monthKey = '0' + (parseInt(date[1], 10) + monthNumberToAdd);
    } else if ((parseInt(date[1], 10) + monthNumberToAdd) > 12) {
      monthKey = '0' + (parseInt(date[1], 10) + monthNumberToAdd - 12);
    } else {
      monthKey = (parseInt(date[1], 10) + monthNumberToAdd).toString();
    }

    return months[monthKey];
  }

  formattingDate(date: string) {
    const myDate = date.split('-');
    return myDate[2] + '/' + myDate[1] + '/' + myDate[0];
  }

  checkDetailEmpty() {
      this.displayMessageError = this.details === '';
  }

  filter($event) {
    if ($event.target.value !== '') {
      let filter = null;
      if ($event.target.value.indexOf('/') !== -1) { // date regex
        filter = '';
        const explodeDate = $event.target.value.split('/');
        for (let i = (explodeDate.length - 1); i >= 0; i--) {
          if (i !== (explodeDate.length - 1)) {
            filter += '-';
          }
          filter += explodeDate[i];
        }
      } else if (/(\d+(?:\.\d+)?)/.test($event.target.value)) { // price regex
        const items = this.billGsmDetailsCopy.filter(obj => obj.priceTtc.toString() === $event.target.value);
        if (items.length > 0) {
          filter = items[0].saleHt.toString();
        }
      } else {
        filter = $event.target.value;
      }
      if (filter !== null) {
        this.store.dispatch(new GetBillGsmDetails(this.selectedLine.phoneNumber, parseInt(this.bill.month, 10), 1, 5, filter));
      }
    } else {
      this.store.dispatch(new GetBillGsmDetails(this.selectedLine.phoneNumber, parseInt(this.bill.month, 10), 1, 5, null));
    }
  }

  private getPaginator() {
    return {
      currentSelectedPage: this.billGsmDetails.currentPage,
      selectedLine: this.selectedLine,
      month: parseInt(this.bill.month, 10),
      action: GetBillGsmDetails,
      totalItems: this.billGsmDetails.totalItems,
      type: 'communication',
    } as PaginatorInterface;
  }

  private setPenalty() {
    const splitDate = this.bill.date.split('/');
    this.customerReportingService.getReporting(parseInt(splitDate[2] + splitDate[1], 10)).subscribe(
        res => {
          this.bill.penalty = res.penalty ? res.penalty : null;
        }
    );
  }
}
